export const SUPPORTED_QUESTION_LOCALES = [
  'en',
  'es',
  'fr',
  'de',
  'pt',
  'ru',
  'tl',
  'it',
  'am',
  'ko',
] as const;

export type SupportedQuestionLocale = (typeof SUPPORTED_QUESTION_LOCALES)[number];

const QUESTION_LOCALE_ALIASES: Record<string, SupportedQuestionLocale> = {
  fil: 'tl',
  ph: 'tl',
  'pt-br': 'pt',
  'pt-pt': 'pt',
};

export function normalizeQuestionLocale(locale?: string | null): SupportedQuestionLocale {
  if (!locale) {
    return 'en';
  }

  const normalized = locale.trim().toLowerCase().replace('_', '-');
  const directCode = normalized.split('-')[0];
  const candidate = QUESTION_LOCALE_ALIASES[normalized] || QUESTION_LOCALE_ALIASES[directCode] || directCode;

  return SUPPORTED_QUESTION_LOCALES.includes(candidate as SupportedQuestionLocale)
    ? (candidate as SupportedQuestionLocale)
    : 'en';
}
